import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Grid, InputAdornment, Divider } from '@mui/material';
import { CompareArrows, Send } from '@mui/icons-material';

const TransferInternalPage: React.FC = () => {
  const [formData, setFormData] = useState({
    agency: '',
    account: '',
    beneficiaryName: '',
    beneficiaryDocument: '',
    amount: '',
    description: '',
  });

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Transferência Interna:', formData);
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <CompareArrows sx={{ mr: 1, verticalAlign: 'middle' }} />
        Transferência Entre Contas Sicoob
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 600 }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
            Conta de Destino (Sicoob)
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Agência"
                value={formData.agency}
                onChange={handleChange('agency')}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Conta"
                value={formData.account}
                onChange={handleChange('account')}
                required
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
            Dados do Beneficiário
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nome do Beneficiário"
                value={formData.beneficiaryName}
                onChange={handleChange('beneficiaryName')}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="CPF/CNPJ"
                value={formData.beneficiaryDocument}
                onChange={handleChange('beneficiaryDocument')}
                required
              />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Valor"
                value={formData.amount}
                onChange={handleChange('amount')}
                InputProps={{
                  startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                }}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descrição (opcional)"
                value={formData.description}
                onChange={handleChange('description')}
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<Send />}
              >
                Transferir
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default TransferInternalPage;
